// extracted by css-extract-rspack-plugin
export default {"label":"lXeoTuhRI6INPC_N"};